module.exports = __webpack_public_path__ + "static/img/live.59fe6c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/live.jpg
// module id = K0z1
// module chunks = 7